import { takeLatest, call, put } from "redux-saga/effects";
import { notifyAPI } from "../../utils/axiosInstance";
import { fetchNotificationsSuccess, fetchNotificationsFailure } from "../actions/notificationActions";
import { FETCH_NOTIFICATIONS_REQUEST } from '../constants';

function* fetchNotificationsSaga(action) {
  try {
    const id = action.payload;
    const response = yield call([notifyAPI, 'get'], `/notification/unread?id=${id}`);
    // console.log("saga",response);
    yield put(fetchNotificationsSuccess(response.data)); 
  } catch (error) {
    yield put(fetchNotificationsFailure(error.message)); 
  }
}

export default function* watchFetchNotifications() {
  yield takeLatest(FETCH_NOTIFICATIONS_REQUEST, fetchNotificationsSaga);
}
